import { Link } from "react-router-dom";
import { Heart, MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/config/site";
import { toggleWishlistItem, isWishlisted } from "@/lib/api";
import { useState } from "react";
import { toast } from "sonner";

export const ProductCard = ({ product, testId }) => {
    const [saved, setSaved] = useState(() => isWishlisted(product.slug));
    const wish = (e) => {
        e.preventDefault();
        const now = toggleWishlistItem(product);
        setSaved(now);
        toast.success(now ? "Saved to your wishlist" : "Removed from wishlist");
    };
    return (
        <div className="group relative" data-testid={testId || `product-card-${product.slug}`}>
            <Link to={`/product/${product.slug}`} className="block">
                <div className="relative aspect-[3/4] overflow-hidden border border-gold/10 group-hover:border-gold/50 transition-colors duration-500 bg-charcoal">
                    <img
                        src={product.image}
                        alt={`${product.name} — ${product.category} at BSK Jewellers Amritsar`}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.07]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent opacity-80" />
                    <div className="absolute bottom-0 inset-x-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                        <p className="text-[10px] tracking-[0.3em] uppercase text-gold">{product.category}</p>
                        <h3 className="font-serif text-xl text-ivory mt-1 leading-snug">{product.name}</h3>
                        <p className="text-[11px] text-sand mt-1 tracking-wide">{product.price_note || "Price on request"}</p>
                        <div className="flex items-center gap-4 mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            <span className="text-[10px] tracking-[0.25em] uppercase text-ivory border-b border-gold/60 pb-0.5">View Details</span>
                        </div>
                    </div>
                </div>
            </Link>
            <div className="absolute top-3 right-3 flex flex-col gap-2">
                <button
                    onClick={wish}
                    data-testid={`wishlist-toggle-${product.slug}`}
                    aria-label="Save to wishlist"
                    className={`w-9 h-9 flex items-center justify-center border backdrop-blur-sm transition-colors ${
                        saved ? "bg-gold text-obsidian border-gold" : "bg-obsidian/40 text-ivory border-gold/25 hover:border-gold"
                    }`}
                >
                    <Heart size={15} strokeWidth={1.5} fill={saved ? "currentColor" : "none"} />
                </button>
                <a
                    href={waLink(WA_MESSAGES.product(product.name))}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    data-testid={`enquire-${product.slug}`}
                    aria-label="Enquire on WhatsApp"
                    className="w-9 h-9 flex items-center justify-center bg-obsidian/40 backdrop-blur-sm border border-gold/25 text-ivory hover:text-gold hover:border-gold transition-colors"
                >
                    <MessageCircle size={15} strokeWidth={1.5} />
                </a>
            </div>
        </div>
    );
};

export default ProductCard;
